<template>
  <div class="restrictions-settings">
    <div class="form--row">
      <AllotmentPerAccommodation
        :fluctuationData="fluctuationData"
        :hotelRoomsData="hotelRoomsData"
      />
    </div>

    <SeparateLine :top="20" :right="-10" :bottom="20" :left="-10" />

    <div class="form--row">
      <CheckInDay :fluctuationData="fluctuationData" />
    </div>

    <SeparateLine :top="20" :right="-10" :bottom="20" :left="-10" />

    <div class="form--row">
      <OtherSettings
        :fluctuationData="fluctuationData"
        :crmGroupsData="crmGroupsData"
        :errors="errors"
        @showInputs="showInputs"
      />
    </div>
  </div>
</template>

<script>
import AllotmentPerAccommodation from './AllotmentPerAccommodation'
import CheckInDay from './CheckInDay'
import OtherSettings from './OtherSettings'
import SeparateLine from '@solucoes/components-lib-tmp/src/components/elements/SeparateLine'

export default {
  name: 'RestrictionsSettings',
  components: {
    AllotmentPerAccommodation,
    CheckInDay,
    SeparateLine,
    OtherSettings
  },

  props: {
    fluctuationData: {
      type: Object,
      default: () => ({})
    },

    hotelRoomsData: {
      type: Array,
      default: () => []
    },

    crmGroupsData: {
      type: Array,
      default: () => []
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    showInputs(newVal) {
      this.$emit('showInputs', newVal)
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 24px;
    margin-bottom: 12px;
  }
}
</style>
